
export const FETCH_DOCUMENTATION_REQUEST = 'FETCH_DOCUMENTATION_REQUEST';
export const FETCH_DOCUMENTATION_SUCCESS = 'FETCH_DOCUMENTATION_SUCCESS';
export const FETCH_DOCUMENTATION_FAILURE = 'FETCH_DOCUMENTATION_FAILURE';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';